<template>
  <atoms-popover-v2
    class="inline-flex"
    :class="{'align-sub':!$slots['action-element']}"
    theme="default"
    action-type="click"
    position="bottom"
    has-close
    small-close
  >
    <slot name="action-element">
      <IconsQuestions
        fill="#FFFFFF"
        icon-fill="#193560"
        class="inline align-sub cursor-pointer"
      />
    </slot>
    <template #content>
      <ol class="text-xs list-decimal text-semantic-surface-on-surface list-inside font-normal border-b border-gray-400 mb-2">
        <li class="my-2">
          Check your spam folder
        </li>
        <li class="my-2">
          Check your email address is correct
        </li>
        <li class="my-2">
          <strong class="font-bold underline cursor-pointer text-semantic-primary-default" @click="resendEmail">Resend email</strong>
        </li>
      </ol>
      <p class="text-semantic-surface-on-surface text-xs">
        For more support, email
      </p>
      <a
        :href="`mailto:${contactEmail}`"
        target="_blank"
        class="text-semantic-primary-default text-xs font-bold underline cursor-pointer"
      >
        {{ contactEmail }}
      </a>
    </template>
  </atoms-popover-v2>
</template>

<script setup>

import memberhubConstants from '~/constants/memberhub.constants'

defineOptions({
  name: 'MoleculesDashboardVerificationTooltip'
})

const props = defineProps({
  isGuestUser: {
    type: Boolean,
    default: false
  }
})

const userStore = useUserStore()

const contactEmail = computed(() => {
  return memberhubConstants.CONTACT_EMAIL
})

function resendEmail () {
  if(props.isGuestUser) {
    userStore.guestPasswordResetHandler({ formData:{ email: userStore.getUserProfile?.email } })
    return
  }
  userStore.resendVerification()
}
</script>

<style scoped>

</style>
